import React from 'react'
import PropTypes from 'prop-types'
import FooterNavigation from './FooterNavigation'
import { usePrivacyOptOutCheck } from '../../../utils/hooks'
import { getNavItems } from '../../../utils/common-utils'

const App = props => {
  const {
    content: { navLink },
  } = props

  const showOptOut = usePrivacyOptOutCheck()
  const navItems = getNavItems(navLink, showOptOut)

  return <FooterNavigation navItems={navItems} />
}

App.defaultProps = {
  content: {
    navLink: [],
  },
}

App.propTypes = {
  content: PropTypes.object,
}

export default App
